import React from 'react';

import { PopOver } from '@bringg/react-components';

import { DeliveryBlocksEvent } from '../delivery-blocks-calendar-view';
import DeliveryBlockEventContent from './delivery-blocks-event-content';
import DeliveryBlockEventPopoverContent from './popover/delivery-block-event-popover-content';
import {
	FEATURE_FLAG_RESOURCE_UTILIZATION,
	isOverUtilized
} from 'bringg-web/features/delivery-blocks-v2/utils/delivery-block-utilization';
import { useHasFeatureFlag } from 'bringg-web/utils/feature-flags';

interface Props {
	event: DeliveryBlocksEvent;
	title: string;
}

export enum EventStyles {
	FULL_BACKGROUND = 'rgba(59, 135, 224, 0.88)',
	AVAILABLE_BACKGROUND = 'rgba(255, 255, 255, 0.85)',
	BORDER = '1px solid #cecece',
	FULL_TEXT_COLOR = 'white',
	AVAILABLE_TEXT_COLOR = '#a7a7a7'
}

export const OVER_UTILIZED_EVENT_CLASS_NAME = 'delivery-block-event-over-utilized';

export const eventStyleGetter = (
	{ userIds, originalCapacity, deliveryBlocksResources, utilizationPercent }: DeliveryBlocksEvent,
	isNewModalOfDeliveryBlock: boolean,
	hasUtilizationFeature: boolean
) => {
	const isDeliveryBlockFull = isNewModalOfDeliveryBlock
		? originalCapacity !== 0 && deliveryBlocksResources.length === originalCapacity
		: userIds.length >= originalCapacity;
	const style = {
		backgroundColor: isDeliveryBlockFull ? EventStyles.FULL_BACKGROUND : EventStyles.AVAILABLE_BACKGROUND,
		border: EventStyles.BORDER,
		color: isDeliveryBlockFull ? EventStyles.FULL_TEXT_COLOR : EventStyles.AVAILABLE_TEXT_COLOR
	};

	const className =
		hasUtilizationFeature && isOverUtilized(utilizationPercent) ? OVER_UTILIZED_EVENT_CLASS_NAME : undefined;

	return { style, className };
};

const MOUSE_HOVER_DELAY = 0.5;

const DeliveryBlockEvent = ({ event, title }: Props) => {
	const hasUtilizationFeature = useHasFeatureFlag(FEATURE_FLAG_RESOURCE_UTILIZATION);

	if (hasUtilizationFeature) {
		return (
			<PopOver
				overlayClassName="delivery-block-utilization-popover"
				mouseEnterDelay={MOUSE_HOVER_DELAY}
				placement="right"
				content={<DeliveryBlockEventPopoverContent event={event} title={title} />}
			>
				<DeliveryBlockEventContent event={event} title={title} />
			</PopOver>
		);
	}

	return (
		<PopOver
			overlayClassName="delivery-block-popover"
			mouseEnterDelay={MOUSE_HOVER_DELAY}
			content={<DeliveryBlockEventContent event={event} title={title} />}
		>
			<DeliveryBlockEventContent event={event} title={title} />
		</PopOver>
	);
};

export default DeliveryBlockEvent;
